<template>
  <div class="navigation" :style="cssVar">
    <div
      :class="{ 'info-wrapper': true, cncc: tabName === 'cncc' && scale > 1 }"
    >
      <div class="info-content-box">
        <div
          :class="{ btns: true, 'no-pm': currentLocation.name }"
          style="flex-wrap: wrap;"
        >
          <div
            v-for="(item, index) in displayTabList"
            :key="index"
            :class="{ active: activeTab === item.code }"
            @click="toggleTab(item.code)"
            style="width: 33.33%;"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="location-container" v-if="currentLocation.name">
          <div class="location">
            <img src="@/assets/img-m/navigation/location-active.png" />
            <span
              >为您导航至<span style="color:#EC5F02">{{
                currentLocation.fullName || currentLocation.name
              }}</span></span
            >
          </div>
          <div class="status-container">
            <div
              class="status"
              v-if="
                ['venue', 'parking'].includes(activeTab) &&
                  ![
                    '服贸会VIP停车场（持证）',
                    '服贸会P1停车场（持证）'
                  ].includes(currentLocation.name)
              "
            >
              {{ statusText
              }}<span
                :class="[
                  clssMap[currentFlowSituation.status] || '',
                  situationLoading ? 'situationLoading' : ''
                ]"
                >{{
                  situationLoading
                    ? '更新中...'
                    : currentFlowSituation.status || '未知'
                }}</span
              >
            </div>
            <div class="view-map" @click="toNavigatePage">
              <img src="@/assets/img-m/navigation/view-map.png" />
              <span>到这里去</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;"></div>
    <div :class="{ map: true, [tabName]: true, [activeTab]: true }">
      <img
        src="@/assets/img-m/navigation/north.png"
        alt=""
        class="north"
        v-if="tabName === 'shougang'"
      />
      <img
        class="shougang-map"
        :src="require(`@/assets/img-m/navigation/${tabName}-new.png`)"
      />
      <ul>
        <li
          v-for="(item, index) in computedLocationList"
          :key="index"
          :class="{
            'location-item': true,
            active:
              `${item.lat}_${item.lng}` ===
              `${currentLocation.lat}_${currentLocation.lng}`,
            [`location-item-${index}`]: true,
            [tabName]: true,
            [activeTab]: true,
            [item.linePosition || '']: true,
            [item.lineLength || '']: true,
            hidden: item.hidden
          }"
          @click="currentLocation = item"
        >
          <div>
            <img
              :src="
                `${item.lat}_${item.lng}` ===
                `${currentLocation.lat}_${currentLocation.lng}`
                  ? locationWhite
                  : location
              "
              alt=""
            />
            <span>{{ item.name }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div style="display: flex;"></div>
    <div
      :class="{ 'exhibition-wrapper': true, shougang: tabName === 'shougang' }"
      v-if="activeTab === 'venueAA'"
    >
      <div class="exhibition-container">
        <div class="title">
          <strong>展馆信息</strong>
          <div>
            <span>点击相应展馆号查看展位图 </span>
            <img src="@/assets/img-m/navigation/arrow-down.png" />
          </div>
        </div>
        <div
          v-for="(item, index) in exhibitionList[tabName].filter(
            item => item.link
          )"
          :key="index"
          :class="{
            'exhibition-item': true,
            cncc: tabName === 'cncc',
            [`cncc-${index + 1}`]: tabName === 'cncc'
          }"
          @click="onClickExhibition(item.link)"
        >
          <div :class="{ left: true, yellow: item.isYellowBg }">
            {{ item.no }}
          </div>
          <div class="right">
            <div>{{ item.name }}</div>
            <div class="line"></div>
            <img src="@/assets/img-m/navigation/arrow-right.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import location from '@/assets/img-m/navigation/location.png'
import locationWhite from '@/assets/img-m/navigation/location-white.png'
import { locationList, exhibitionList } from './const'
import { Base64 } from 'js-base64'
import { getFlowSituation } from '@/api/activity-api.js'

const statusTextMap = {
  venue: '当前场馆状态：',
  parking: '当前区域状态：'
}

const clssMap = {
  正常: 'normal',
  拥挤: 'crowded',
  爆满: 'full'
}

export default {
  name: 'navigation',
  components: {},
  data() {
    return {
      clssMap,
      tabName: 'shougang',
      // 这是原先的tab，保留
      tabList: [
        // {
        //   code: 'cncc',
        //   name: '国家会议中心'
        // },
        {
          code: 'shougang',
          name: '首钢园'
        }
      ],
      // 改动太多，用一个新的tabList来处理
      displayTabList: [
        {
          name: '场馆',
          code: 'venue'
        },
        {
          name: '会议室',
          code: 'meeting'
        },
        {
          name: '停车场',
          code: 'parking'
        },
        {
          name: '登录厅',
          code: 'lobby'
        },
        {
          name: '公共区',
          code: 'public'
        },
        {
          name: '社会停车场',
          code: 'socialParking'
        }
      ],
      activeTab: 'venue',
      location,
      locationWhite,
      currentLocation: {},
      locationList,
      exhibitionList,
      scale: 1,
      flowSituations: [],
      situationLoading: false
    }
  },
  watch: {
    activeTab: {
      handler: function(newVal) {
        if (['venue', 'parking'].includes(newVal)) {
          this.fetchFlowSituations()
        }
      },
      immediate: true
    }
  },
  computed: {
    statusText() {
      return statusTextMap[this.activeTab] || '当前场馆状态：'
    },
    cssVar() {
      return {
        '--mapMargin': Number((this.scale * 44).toFixed(2)) + 'px',
        '--panelWidth': Number((this.scale * 335).toFixed(2)) + 'px',
        '--scale': this.scale,
        '--exhibitionMargin': Number((this.scale * 44).toFixed(2)) * 2 + 'px'
      }
    },
    computedLocationList() {
      return this.locationList[this.tabName].filter(
        item => item.tab === this.activeTab
      )
    },
    currentFlowSituation() {
      if (
        ['venue', 'parking'].includes(this.activeTab) &&
        this.flowSituations.length
      ) {
        const situation = this.flowSituations.find(item =>
          this.currentLocation.name.includes(item.name)
        )
        return situation || {}
      }
      return {}
    }
  },
  methods: {
    async fetchFlowSituations() {
      try {
        this.situationLoading = true
        const res = await getFlowSituation()
        this.flowSituations = (Array.isArray(res) ? res : []).map(item => {
          // 如果item的key是北京首钢园P2停车场，将其改为服贸会P2停车场；首钢园-服贸会P5停车场改为服贸会P5停车场（持证）；北京首钢园南区三炼钢停车场改为服贸会P3停车场（持证）；北京首钢园制氧南地下停车场改为服贸会P4停车场（持证）
          // P1和VIP暂时没找到对应关系
          const nameMapping = {
            北京首钢园P2停车场: '服贸会P2停车场',
            '北京首钢园-服贸会P5停车场': '服贸会P5停车场（持证）',
            北京首钢园南区三炼钢停车场: '服贸会P3停车场（持证）',
            北京首钢园制氧南地下停车场: '服贸会P4停车场（持证）'
          }
          if (nameMapping[item.name]) {
            item.name = nameMapping[item.name]
          }
          return item
        })
      } catch (error) {
        console.error('Error fetching flow situations:', error)
      } finally {
        this.situationLoading = false
      }
    },
    onClickExhibition(link) {
      if (link) {
        const ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          //微信环境下
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              wx.miniProgram.navigateTo({
                url: `/pagesA/web_view/web_view?base64=${Base64.encodeURI(
                  link
                )}`
              })
            }
          })
        } else {
          window.open(link)
        }
      }
    },
    toggleTab(activeTab) {
      this.activeTab = activeTab
      this.currentLocation =
        this.locationList[this.tabName]
          .filter(item => item.tab === this.activeTab)
          .find(item => item.defaultActive) ||
        this.locationList[this.tabName].filter(
          item => item.tab === this.activeTab
        )[0]
    },
    // 将百度坐标转换为腾讯坐标
    bd09togcj02(bd_lng, bd_lat) {
      const x_PI = (3.14159265358979324 * 3000.0) / 180.0
      const x = bd_lng - 0.0065
      const y = bd_lat - 0.006
      const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI)
      const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI)
      const gg_lng = z * Math.cos(theta)
      const gg_lat = z * Math.sin(theta)
      return [gg_lng, gg_lat]
    },

    toNavigatePage() {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.includes('ciftis-app')) {
        this.$toast('请在微信小程序中使用导航功能')
        return
      }
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //微信环境下
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            // 2025:今年给的是高德的坐标，不用做坐标系转换了
            const [longitude, latitude] = [
              Number(this.currentLocation.lng),
              Number(this.currentLocation.lat)
            ]
            wx.miniProgram.navigateTo({
              url: `/pagesA/web_view/web_view?lat=${latitude}&lng=${longitude}&name=${this.currentLocation.name}`
            })
          }
        })
      }
    },
    findLocationByQuery() {
      const query = this.$route.query
      // 如果query.name包含首钢园，切换tabName为shougang
      // if (query.name && query.name.includes('首钢园')) {
      //   this.tabName = 'shougang'
      // } else {
      //   this.tabName = 'cncc'
      // }
      // 2025年只有首钢园
      this.tabName = 'shougang'
      // 如果query.lat和query.lng存在，设置currentLocation，同时设置activeTab
      this.currentLocation = this.locationList[this.tabName].find(
        item => item.lat === query.lat && item.lng === query.lng
      )

      // 如果没有找到对应的地点，默认选中第一个
      if (!this.currentLocation) {
        this.currentLocation = this.locationList[this.tabName][0]
      }

      this.activeTab = this.currentLocation
        ? this.currentLocation.tab
        : this.displayTabList[0].code
    }
  },
  mounted() {
    // 获取屏幕尺寸，计算相对于375宽度的倍数，用于地图上点的定位
    const width = window.screen.width
    // 计算倍数
    this.scale = Number((width / 375).toFixed(2))
  },
  created() {
    if (this.$route.query.lat && this.$route.query.lng) {
      this.findLocationByQuery()
    } else {
      this.toggleTab(this.activeTab)
    }
  }
}
</script>
<style lang="scss" scoped>
.navigation {
  min-height: 100vh;
  & > * {
    box-sizing: border-box;
  }
  background-color: #f7f7f7;
  height: auto;
  .info-wrapper {
    position: relative;
    margin: 20px 0;
    &.cncc {
      padding-bottom: var(--mapMargin);
      margin-bottom: 0;
    }
    width: 100%;
    .info-content-box {
      overflow: hidden;
      box-sizing: border-box;
      border-radius: 10px;
      background: #fff;
      width: var(--panelWidth);
      margin: 0 auto 15px auto;
      height: auto;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
      font-weight: 500;
      .btns {
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 0;
        height: 100%;
        padding: 20px 15px;
        &.no-pm {
          padding-bottom: 0;
        }

        div {
          position: relative;
          text-align: center;
          width: 305px;
          height: 40px;
          line-height: 40px;
          background: rgba(254, 140, 1, 0.15);
          color: #fe8c01;
          transition: all 0.3s;
          font-size: 16px;
          overflow: hidden;
          &::after {
            position: absolute;
            box-sizing: border-box;
            content: ' ';
            pointer-events: none;
            top: -50%;
            right: -50%;
            bottom: -50%;
            left: -50%;
            border: 1px solid rgba(254, 140, 1, 0.35);
            -webkit-transform: scale(0.5);
            transform: scale(0.5);
          }
          &.active {
            background: linear-gradient(-90deg, #fe8c01 0%, #ff5722 100%);
            color: #fff;
          }
          &:last-child {
            border-bottom-right-radius: 5px;
          }
          &:nth-child(3) {
            border-top-right-radius: 5px;
          }
          &:nth-child(4) {
            border-bottom-left-radius: 5px;
          }

          &:first-child {
            border-top-left-radius: 5px;
            // border-bottom-left-radius: 5px;
          }
        }
      }

      .location-container {
        padding: 0 15px 20px 15px;
        background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.7) 0%,
          #f38d0014 97%
        );

        .location {
          margin-top: 16px;
          display: flex;
          gap: 5px;
          height: 46px;
          line-height: 1.4;
          align-items: center;
          flex-shrink: none;

          img {
            width: 12px;
            height: 14px;
            min-width: 12px;
          }
          span {
            font-size: 12px;
          }
        }
        .view-map {
          margin-left: auto;
          display: flex;
          gap: 5px;
          align-items: center;
          background: linear-gradient(0deg, #6ec8ff 0%, #00a0e8 100%);
          height: 30px;
          width: 100px;
          border-radius: 4px;
          justify-content: center;
          img {
            width: 16px;
            height: 16px;
          }
          span {
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .status-container {
        display: flex;
        align-items: center;
        .status {
          font-weight: 400;
          font-size: 13px;
          line-height: 14px;
          letter-spacing: 0px;
          text-align: center;
          color: rgba(0, 0, 0, 0.6);
          span {
            padding: 4px;
            border-radius: 4px;
            color: #fff;
            &.normal,
            &.situationLoading {
              background-color: #d6c400;
            }
            &.crowded {
              background-color: #ec5f02;
            }
            &.full {
              background-color: #da291c;
            }
          }
        }
      }
    }
  }
  .map {
    position: relative;
    width: 350px;
    height: 100%;
    margin: var(--mapMargin) auto;
    transform: scale(var(--scale));
    &.socialParking {
      margin-top: calc(var(--mapMargin) + 40px);
    }
    img {
      width: 100%;
      height: auto;
      transform: scale(1.1);
    }
    img.north {
      position: absolute;
      top: -14px;
      right: 16px;
      width: 20px;
      height: 40px;
    }
    .location-item {
      position: absolute;
      max-width: 80%;
      border-radius: 24px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      &.hidden {
        display: none;
      }
      div {
        position: relative;
        z-index: 5;
        display: flex;
        align-items: center;
        gap: 2px;
        padding: 6px 6px;
        line-height: 1.4;
        background-color: #fff;
        border-radius: 24px;
      }
      img {
        width: 12px;
        height: 100%;
        margin: 0 2px 0 0;
      }
      span {
        font-size: 10px;
        color: #000;
      }
      &.active {
        div {
          background: linear-gradient(-90deg, #fe8c01 0%, #ff5722 100%);
        }
        span {
          color: #fff;
        }
        &::before,
        &::after {
          background-color: #ec5f02;
          z-index: 1;
        }
      }
      &.left {
        &::before {
          right: 117px;
        }
        &::after {
          right: 114px;
        }
      }
      &.middle {
        &::before {
          height: 20px;
          top: 25px;
        }
        &::after {
          top: 44px;
        }
      }
      &::before {
        content: '';
        position: absolute;
        top: 26px;
        right: 10px;
        transform: translateX(-50%);
        width: 1px;
        height: 40px;
        background-color: #000;
        pointer-events: none;
      }
      &::after {
        content: '';
        position: absolute;
        top: 65px;
        right: 7px;
        transform: translateX(-50%);
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #000;
      }
      &.shougang {
        &.parking {
          &.location-item-0 {
            top: 65px;
            left: 30px;
            &::before {
              right: 50px;
              top: 24px;
            }
            &::after {
              right: 47px;
              top: 63px;
            }
          }
          &.location-item-1 {
            top: 263px;
            right: 0px;
            &::before {
              left: -26px;
              top: 13px;
              height: 1px;
              width: 37px;
            }
            &::after {
              left: -44px;
              top: 11px;
            }
          }
          &.location-item-2 {
            top: 350px;
            right: 0px;
            &::before {
              height: 30px;
              width: 1px;
              right: 58px;
              top: -18px;
            }
            &::after {
              top: -18px;
              right: 55px;
            }
          }
          &.location-item-3 {
            top: 354px;
            left: 57px;
            &::before {
              height: 50px;
              top: -30px;
              right: 46px;
            }
            &::after {
              top: -31px;
              right: 43px;
            }
          }
          &.location-item-4 {
            top: 282px;
            left: 0px;
            &::before {
              height: 24px;
              top: -25px;
              right: 53px;
            }
            &::after {
              top: -27px;
              right: 50px;
            }
          }
          &.location-item-5 {
            top: 218px;
            right: 20px;
            &::before {
              height: 30px;
              top: -15px;
              left: 9px;
            }
            &::after {
              top: -17px;
              left: 9px;
            }
          }
          &.location-item-6 {
            top: 51px;
            left: 176px;
            &::before {
              height: 38px;
              top: 24px;
              left: -1px;
            }
            &::after {
              top: 60px;
              left: -1px;
            }
          }
          &.location-item-7 {
            top: 10px;
            left: 30px;
            &::before {
              height: 82px;
              top: 24px;
              right: 51px;
            }
            &::after {
              top: 103px;
              right: 48px;
            }
          }
          &.location-item-8 {
            top: 150px;
            right: 0px;
            &::before {
              height: 40px;
              width: 1px;
              top: -14px;
              left: -8px;
            }
            &::after {
              top: -14px;
              left: -8px;
            }
          }
        }
        &.venue {
          &.location-item-0 {
            top: 135px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 0 1px 1px 0;
              }
            }
            &::before {
              right: -124px;
              top: 13px;
              height: 1px;
              width: 100px;
              background: transparent;
              border: 1px solid black;
              border-width: 0 1px 1px 0;
            }
            &::after {
              right: -80.5px;
              top: 12px;
            }
          }
          &.location-item-1 {
            top: 50px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-bottom: none;
              }
            }
            &::before {
              right: -123px;
              top: 13px;
              height: 58px;
              width: 130px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-bottom: none;
            }
            &::after {
              right: -61.5px;
              top: 69px;
            }
          }
          &.location-item-2 {
            top: 100px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-bottom: none;
              }
            }
            &::before {
              right: -114px;
              top: 13px;
              height: 8px;
              width: 112px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-bottom: none;
            }
            &::after {
              right: -61.5px;
              top: 19px;
            }
          }
          &.location-item-3 {
            top: 0px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-bottom: none;
              }
            }
            &::before {
              right: -152px;
              top: 12px;
              height: 105px;
              width: 115px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-bottom: none;
            }
            &::after {
              right: -97.5px;
              top: 115px;
            }
          }
          &.location-item-4 {
            top: 70px;
            right: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-bottom: none;
              }
            }
            &::before {
              left: -12px;
              top: 12px;
              height: 60px;
              width: 35px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-bottom: none;
            }
            &::after {
              left: -29px;
              top: 70px;
            }
          }

          &.location-item-5 {
            top: 138px;
            right: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-bottom: none;
              }
            }
            &::before {
              left: -6px;
              top: 12px;
              height: 1px;
              width: 30px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-bottom: none;
            }
            &::after {
              left: -20.5px;
              top: 10.5px;
            }
          }

          &.location-item-6 {
            top: 24px;
            right: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-bottom: none;
              }
            }
            &::before {
              left: 0;
              top: 12px;
              height: 135px;
              width: 105px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-bottom: none;
            }
            &::after {
              left: -52px;
              top: 145px;
            }
          }

          &.location-item-7 {
            top: 190px;
            right: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 0 0 1px 1px;
                background: none;
              }
            }
            &::before {
              width: 42px;
              height: 20px;
              left: -17px;
              top: -7px;
              border: 1px solid black;
              border-width: 0 0 1px 1px;
              background: none;
            }
            &::after {
              left: -37px;
              top: -8px;
            }
          }
          &.location-item-8 {
            top: 220px;
            right: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 0 0 1px 1px;
                background: none;
              }
            }
            &::before {
              left: -14px;
              top: 13px;
              width: 39px;
              height: 1px;
              border: 1px solid black;
              border-width: 0 0 1px 1px;
              background: none;
            }
            &::after {
              left: -34px;
              top: 11px;
            }
          }

          &.location-item-9 {
            top: 272px;
            right: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 0 0 1px 1px;
                background: none;
              }
            }
            &::before {
              left: -14.5px;
              top: -19px;
              width: 39.5px;
              height: 34px;
              border: 1px solid black;
              border-width: 0 0 1px 1px;
              background: none;
            }
            &::after {
              left: -34.5px;
              top: -21px;
            }
          }

          &.location-item-10 {
            top: 234px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-top: none;
              }
            }
            &::before {
              right: -133px;
              top: -3px;
              height: 16px;
              width: 102px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-top: none;
            }
            &::after {
              right: -86px;
              top: -4px;
            }
          }

          &.location-item-11 {
            top: 202px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-top: none;
              }
            }
            &::before {
              right: -130px;
              top: 3px;
              height: 11px;
              width: 106px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-top: none;
            }
            &::after {
              right: -80.5px;
              top: 1px;
            }
          }

          &.location-item-12 {
            top: 168px;
            left: 5px;
            &::before {
              right: -134px;
              top: 13px;
              height: 1px;
              width: 120px;
            }
            &::after {
              right: -78px;
              top: 11px;
            }
          }

          &.location-item-13 {
            top: 272px;
            left: 5px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-top: none;
              }
            }
            &::before {
              right: -150px;
              top: -89px;
              height: 102px;
              width: 114px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-top: none;
            }
            &::after {
              right: -96px;
              top: -91px;
            }
          }
        }
        &.meeting {
          &.location-item-0 {
            top: 140px;
            right: 15px;
            &::before {
              height: 1px;
              width: 74px;
              right: 40px;
              top: 13px;
            }
            &::after {
              right: 147px;
              top: 12px;
            }
          }
          &.location-item-1 {
            top: 184px;
            right: 10px;
            &::before {
              height: 1px;
              width: 83px;
              right: 50px;
              top: 13px;
            }
            &::after {
              left: -66px;
              top: 12px;
            }
          }
          &.location-item-2 {
            top: 195px;
            left: 70px;
            &::before {
              height: 1px;
              left: 60px;
              top: 13px;
              width: 63px;
            }
            &::after {
              left: 91px;
              top: 11px;
            }
          }
          &.location-item-3 {
            top: 220px;
            right: 0px;
            &::before {
              height: 1px;
              width: 89px;
              right: 50px;
              top: 13px;
            }
            &::after {
              left: -85px;
              top: 12px;
            }
          }
          &.location-item-4 {
            top: 310px;
            right: 95px;
            &::before {
              height: 87px;
              left: 9px;
              top: -64px;
            }
            &::after {
              left: 9px;
              top: -64px;
            }
          }
          &.location-item-5 {
            top: 34px;
            left: 95px;
            &::before {
              left: -4px;
              top: 13px;
              height: 40px;
            }
            &::after {
              left: -4px;
              top: 50px;
            }
          }
          &.location-item-6 {
            top: 70px;
            left: 0px;
            &::before {
              height: 89px;
              left: 26px;
              top: 13px;
            }
            &::after {
              left: 26px;
              top: 99px;
            }
          }
          &.location-item-7 {
            top: 140px;
            left: 88px;
            &::before {
              left: 10px;
              top: 13px;
              height: 1px;
              width: 75px;
            }
            &::after {
              left: 46px;
              top: 12px;
            }
          }
          &.location-item-8 {
            top: 112px;
            left: 88px;
            &::before {
              left: 10px;
              top: 13px;
              width: 60px;
              height: 1px;
            }
            &::after {
              left: 40px;
              top: 12px;
            }
          }
          &.location-item-9 {
            top: 30px;
            left: 164px;
            &::before {
              left: -14px;
              top: 13px;
              height: 77px;
            }
            &::after {
              left: -14px;
              top: 89px;
            }
          }
          &.location-item-10 {
            top: 65px;
            right: 132px;
            &::before {
              left: 5px;
              top: 13px;
              height: 68px;
            }
            &::after {
              left: 5px;
              top: 79px;
            }
          }
        }
        &.lobby {
          &.location-item-0 {
            top: 48px;
            left: 84px;
            &::before {
              height: 41px;
              right: 49px;
              top: 23px;
            }
            &::after {
              right: 46px;
              top: 63px;
            }
          }
          &.location-item-1 {
            top: 152px;
            right: 0px;
            &::before {
              height: 1px;
              width: 77px;
              left: -23px;
              top: 13px;
            }
            &::after {
              left: -62px;
              top: 12px;
            }
          }
          &.location-item-2 {
            top: 201px;
            right: 0;
            &::before {
              left: -25px;
              top: 13px;
              height: 1px;
              width: 71px;
            }
            &::after {
              left: -60px;
              top: 12px;
            }
          }
          &.location-item-3 {
            top: 292px;
            right: 54px;
            &::before {
              left: 14px;
              top: -34px;
              height: 40px;
            }
            &::after {
              left: 14px;
              top: -35px;
            }
          }
          &.location-item-4 {
            top: 239px;
            left: 37px;
            &::before {
              right: -25px;
              top: 11px;
              height: 1px;
              width: 50px;
            }
            &::after {
              right: -4px;
              top: 9px;
            }
          }
          &.location-item-5 {
            top: 173px;
            left: 18px;
            &::before {
              right: -25px;
              top: 13px;
              height: 1px;
              width: 44px;
            }
            &::after {
              right: -09px;
              top: 11px;
            }
          }
          &.location-item-6 {
            top: 114px;
            right: -6px;
            &::before {
              left: 4px;
              top: 21px;
              height: 24px;
            }
            &::after {
              left: 4px;
              top: 42px;
            }
          }
          &.location-item-7 {
            top: 202px;
            right: 0;
            &::before {
              left: 40px;
              top: -12px;
              height: 12px;
            }
            &::after {
              left: 40px;
              top: -14px;
            }
          }
          &.location-item-8 {
            top: 286px;
            left: 0;
            &::before {
              left: 113px;
              top: -16px;
              height: 16px;
            }
            &::after {
              left: 113px;
              top: -18px;
            }
          }
          &.location-item-9 {
            top: 180px;
            left: 0;
            &::before {
              left: 72px;
              top: -16px;
              height: 16px;
            }
            &::after {
              left: 72px;
              top: -18px;
            }
          }
          &.location-item-10 {
            top: 66px;
            left: 0px;
            &::before {
              height: 32px;
              left: 80px;
              top: 23px;
            }
            &::after {
              left: 80px;
              top: 52px;
            }
          }
          &.location-item-11 {
            top: 4px;
            left: 0px;
            &::before {
              height: 34px;
              left: 80px;
              top: 23px;
            }
            &::after {
              left: 80px;
              top: 56px;
            }
          }
        }
        &.public {
          &.location-item-0 {
            top: -18px;
            left: 0;
            &::before {
              height: 63px;
              right: 56px;
              top: 24px;
            }
            &::after {
              top: 84px;
              right: 53px;
            }
          }
          &.location-item-1 {
            top: 183px;
            right: 8px;
            &::before {
              height: 1px;
              width: 80px;
              left: -27px;
              top: 13px;
            }
            &::after {
              left: -66px;
              top: 12px;
            }
          }
          &.location-item-2 {
            top: 49px;
            left: 142px;
            &::before {
              height: 22px;
              left: -24px;
              top: 23px;
            }
            &::after {
              left: -24px;
              top: 43px;
            }
          }
          &.location-item-3 {
            top: 104px;
            right: 51px;
            &::before {
              height: 25px;
              left: 15px;
              top: -17px;
            }
            &::after {
              left: 15px;
              top: -18px;
            }
          }
          &.location-item-4 {
            top: 12px;
            right: 74px;
            &::before {
              height: 66px;
              left: -22px;
              top: 23px;
            }
            &::after {
              left: -22px;
              top: 87px;
            }
          }
          &.location-item-5 {
            top: 113px;
            left: 0px;
            &::before {
              height: 41px;
              left: 29px;
              top: 13px;
            }
            &::after {
              left: 29px;
              top: 51px;
            }
          }
          &.location-item-6 {
            top: 281px;
            left: 0px;
            &::before {
              height: 38px;
              left: 68px;
              top: -33px;
            }
            &::after {
              left: 68px;
              top: -36px;
            }
          }
          &.location-item-7 {
            top: 194px;
            left: 0px;
            &::before {
              left: 33px;
              top: -14px;
              height: 14px;
            }
            &::after {
              left: 33px;
              top: -16px;
            }
          }
          &.location-item-8 {
            top: 268px;
            left: 0px;
            &::before {
              left: 61px;
              top: -24px;
              height: 33px;
            }
            &::after {
              left: 61px;
              top: -26px;
            }
          }
        }
        &.socialParking {
          &.location-item-0 {
            top: 8px;
            left: 0;
            &::before {
              height: 18px;
              right: 56px;
              top: 24px;
            }
            &::after {
              right: 53px;
              top: 42px;
            }
          }
          &.location-item-1 {
            top: -51px;
            left: 8px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-bottom: none;
              }
            }
            &::before {
              right: -24px;
              top: 13px;
              height: 73px;
              width: 50px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-bottom: none;
            }
            &::after {
              right: -2.5px;
              top: 85px;
            }
          }
          &.location-item-2 {
            top: 16px;
            left: 138px;
            z-index: 10;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-bottom: none;
              }
            }
            &::before {
              left: -26px;
              top: 12px;
              height: 54px;
              width: 79px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-bottom: none;
            }
            &::after {
              left: -64.5px;
              top: 64px;
            }
          }
          &.location-item-3 {
            top: -52px;
            left: 140px;
            &::before {
              height: 96px;
              right: 117px;
              top: 24px;
            }
            &::after {
              right: 114px;
              top: 119px;
            }
          }

          &.location-item-4 {
            top: 334px;
            left: 20px;
            z-index: 10;
            &.active {
              z-index: 11;
            }
            &::before {
              left: 52px;
              top: -189px;
              height: 194px;
            }
            &::after {
              left: 52px;
              top: -191px;
            }
          }

          &.location-item-5 {
            top: 132px;
            left: 200px;
            &::before {
              left: -52px;
              top: 10px;
              height: 1px;
              width: 124px;
            }
            &::after {
              left: -114.5px;
              top: 9px;
            }
          }
          &.location-item-6 {
            top: -21px;
            left: -6px;
            &::before {
              height: 164px;
              left: 30px;
              top: 13px;
            }
            &::after {
              left: 30px;
              top: 176px;
            }
          }
          &.location-item-7 {
            top: 192px;
            right: 74px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 1px 0 0 1px;
              }
            }
            &::before {
              width: 104px;
              height: 40px;
              background: transparent;
              border: 1px solid black;
              border-width: 1px 0 0 1px;
              left: -31px;
              top: 8px;
            }
            &::after {
              left: -82px;
              top: 47px;
            }
          }
          &.location-item-8 {
            top: 234px;
            right: 46px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 1px 0 0 1px;
              }
            }
            &::before {
              left: -86px;
              top: 6px;
              height: 20px;
              width: 160px;
              background: transparent;
              border: 1px solid black;
              border-width: 1px 0 0 1px;
            }
            &::after {
              left: -165.5px;
              top: 25px;
            }
          }
          &.location-item-9 {
            top: 366px;
            left: 10px;
            z-index: 10;
            &::before {
              left: 109px;
              top: -76px;
              height: 86px;
            }
            &::after {
              left: 109px;
              top: -78px;
            }
          }

          &.location-item-10 {
            top: 76px;
            right: 30px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 1px 0 0 1px;
              }
            }
            &::before {
              left: -70px;
              top: 10px;
              height: 24px;
              width: 145px;
              background: transparent;
              border: 1px solid black;
              border-width: 1px 0 0 1px;
            }
            &::after {
              left: -142px;
              top: 34px;
            }
          }

          &.location-item-11 {
            top: 46px;
            right: 10px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-bottom: none;
              }
            }
            &::before {
              left: -66px;
              top: 13px;
              height: 54px;
              width: 145px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-bottom: none;
            }
            &::after {
              left: -138px;
              top: 64px;
            }
          }
          &.location-item-12 {
            top: 264px;
            right: 0;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 0 0 1px 1px;
              }
            }
            &::before {
              left: -71px;
              top: -88px;
              height: 99px;
              width: 153px;
              background: transparent;
              border: 1px solid black;
              border-width: 0 0 1px 1px;
            }
            &::after {
              left: -146.5px;
              top: -89px;
            }
          }

          &.location-item-13 {
            top: 162px;
            right: 36px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-top: none;
              }
            }
            &::before {
              left: -62px;
              top: 9px;
              height: 1px;
              width: 138px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-top: none;
            }
            &::after {
              left: -130.5px;
              top: 8px;
            }
          }

          &.location-item-14 {
            top: 310px;
            right: 43px;
            &.active {
              z-index: 11;
              &::before {
                border: 1px solid #ec5f02;
                border-right: none;
                border-top: none;
              }
            }
            &::before {
              left: -91px;
              top: -137px;
              height: 145px;
              width: 125px;
              background: transparent;
              border: 1px solid black;
              border-right: none;
              border-top: none;
            }
            &::after {
              left: -153px;
              top: -139px;
            }
          }

          &.location-item-15 {
            top: -15px;
            right: 30px;
            z-index: 10;
            &::before {
              left: 8px;
              top: 18px;
              height: 39px;
            }
            &::after {
              left: 8px;
              top: 54px;
            }
          }

          &.location-item-16 {
            top: 339px;
            right: 52px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-width: 0 0 1px 1px;
              }
            }
            &::before {
              left: -80px;
              top: -146px;
              height: 154px;
              width: 196px;
              background: transparent;
              border: 1px solid black;
              border-width: 0 0 1px 1px;
            }
            &::after {
              left: -178px;
              top: -147px;
            }
          }

          &.location-item-17 {
            top: 372px;
            right: 0px;
            &::before {
              right: 57px;
              top: -40px;
              height: 60px;
              width: 1px;
            }
            &::after {
              right: 54px;
              top: -42px;
            }
          }

          &.location-item-18 {
            top: 404px;
            right: 110px;
            &::before {
              left: 12px;
              top: -83px;
              height: 91px;
            }
            &::after {
              left: 12px;
              top: -84px;
            }
          }
          &.location-item-19 {
            top: 366px;
            left: 0px;
            &.active {
              &::before {
                border: 1px solid #ec5f02;
                border-left: none;
                border-top: none;
              }
            }
            &::before {
              right: -81px;
              top: -66px;
              height: 80px;
              width: 54px;
              background: transparent;
              border: 1px solid black;
              border-left: none;
              border-top: none;
            }
            &::after {
              right: -57px;
              top: -69px;
            }
          }
        }

        // The new map keeps the labels in place but moves their map anchors.
        &.parking {
          &.location-item-0 {
            --map-point-shift-x: 37.42px;
            --map-point-shift-y: -0.06px;
          }
          &.location-item-1 {
            --map-point-shift-x: 37.89px;
            --map-point-shift-y: -0.22px;
          }
          &.location-item-2 {
            --map-point-shift-x: 40.77px;
            --map-point-shift-y: -4.77px;
          }
          &.location-item-3 {
            --map-point-shift-x: 35.67px;
            --map-point-shift-y: 3.74px;
          }
          &.location-item-4 {
            --map-point-shift-x: 34.46px;
            --map-point-shift-y: 5.51px;
          }
          &.location-item-5 {
            --map-point-shift-x: 38.79px;
            --map-point-shift-y: -2.04px;
          }
          &.location-item-6 {
            --map-point-shift-x: 39.27px;
            --map-point-shift-y: -3.24px;
          }
          &.location-item-7 {
            --map-point-shift-x: 38.46px;
            --map-point-shift-y: -1.86px;
          }
          &.location-item-8 {
            --map-point-shift-x: 38.78px;
            --map-point-shift-y: -2.29px;
          }
        }

        &.meeting {
          &.location-item-0 {
            --map-point-shift-x: 39px;
            --map-point-shift-y: -2.61px;
          }
          &.location-item-1 {
            --map-point-shift-x: 37.85px;
            --map-point-shift-y: -0.48px;
          }
          &.location-item-2 {
            --map-point-shift-x: 37.58px;
            --map-point-shift-y: 0;
          }
          &.location-item-3 {
            --map-point-shift-x: 37.4px;
            --map-point-shift-y: 0.44px;
          }
          &.location-item-4 {
            --map-point-shift-x: 37.18px;
            --map-point-shift-y: 0.87px;
          }
          &.location-item-5 {
            --map-point-shift-x: 37.13px;
            --map-point-shift-y: 0.23px;
          }
          &.location-item-6 {
            --map-point-shift-x: 33.84px;
            --map-point-shift-y: 6.14px;
          }
          &.location-item-7 {
            --map-point-shift-x: 37.51px;
            --map-point-shift-y: -0.12px;
          }
          &.location-item-8 {
            --map-point-shift-x: 37.68px;
            --map-point-shift-y: -0.53px;
          }
          &.location-item-9 {
            --map-point-shift-x: 38.38px;
            --map-point-shift-y: -1.72px;
          }
          &.location-item-10 {
            --map-point-shift-x: 38.62px;
            --map-point-shift-y: -2.01px;
          }
        }

        &.lobby {
          &.location-item-0 {
            --map-point-shift-x: 38.24px;
            --map-point-shift-y: -1.52px;
          }
          &.location-item-1 {
            --map-point-shift-x: 38.72px;
            --map-point-shift-y: -2.08px;
          }
          &.location-item-2 {
            --map-point-shift-x: 38.08px;
            --map-point-shift-y: -0.8px;
          }
          &.location-item-3 {
            --map-point-shift-x: 38.11px;
            --map-point-shift-y: -0.66px;
          }
          &.location-item-4 {
            --map-point-shift-x: 36.59px;
            --map-point-shift-y: 1.86px;
          }
          &.location-item-5 {
            --map-point-shift-x: 37.05px;
            --map-point-shift-y: 0.8px;
          }
        }

        &.public {
          &.location-item-0 {
            --map-point-shift-x: 36.78px;
            --map-point-shift-y: 0.75px;
          }
          &.location-item-1 {
            --map-point-shift-x: 36.68px;
            --map-point-shift-y: 1.51px;
          }
          &.location-item-2 {
            --map-point-shift-x: 37.66px;
            --map-point-shift-y: -0.63px;
          }
          &.location-item-3 {
            --map-point-shift-x: 39.58px;
            --map-point-shift-y: -3.94px;
          }
          &.location-item-4 {
            --map-point-shift-x: 36.77px;
            --map-point-shift-y: 0.92px;
          }
          &.location-item-5 {
            --map-point-shift-x: 34px;
            --map-point-shift-y: 5.88px;
          }
          &.location-item-6 {
            --map-point-shift-x: 34.19px;
            --map-point-shift-y: 5.91px;
          }
        }

        &.socialParking {
          &.location-item-0 {
            --map-point-shift-x: 35.59px;
            --map-point-shift-y: 2.68px;
          }
          &.location-item-1 {
            --map-point-shift-x: 37.83px;
            --map-point-shift-y: -1.14px;
          }
          &.location-item-2 {
            --map-point-shift-x: 36.33px;
            --map-point-shift-y: 1.57px;
          }
          &.location-item-3 {
            --map-point-shift-x: 39.03px;
            --map-point-shift-y: -3.04px;
          }
          &.location-item-4 {
            --map-point-shift-x: 35.58px;
            --map-point-shift-y: 3.11px;
          }
          &.location-item-5 {
            --map-point-shift-x: 36.05px;
            --map-point-shift-y: 2.32px;
          }
          &.location-item-6 {
            --map-point-shift-x: 33.65px;
            --map-point-shift-y: 6.43px;
          }
          &.location-item-7 {
            --map-point-shift-x: 34.62px;
            --map-point-shift-y: 5.18px;
          }
          &.location-item-8 {
            --map-point-shift-x: 33.36px;
            --map-point-shift-y: 7.36px;
          }
          &.location-item-9 {
            --map-point-shift-x: 35.14px;
            --map-point-shift-y: 4.47px;
          }
          &.location-item-10 {
            --map-point-shift-x: 36.23px;
            --map-point-shift-y: 1.87px;
          }
          &.location-item-11 {
            --map-point-shift-x: 36.97px;
            --map-point-shift-y: 0.62px;
          }
          &.location-item-12 {
            --map-point-shift-x: 36.09px;
            --map-point-shift-y: 2.39px;
          }
          &.location-item-13 {
            --map-point-shift-x: 35.55px;
            --map-point-shift-y: 3.29px;
          }
          &.location-item-14 {
            --map-point-shift-x: 34.42px;
            --map-point-shift-y: 5.19px;
          }
          &.location-item-15 {
            --map-point-shift-x: 41.05px;
            --map-point-shift-y: -6.52px;
          }
          &.location-item-16 {
            --map-point-shift-x: 33.47px;
            --map-point-shift-y: 6.9px;
          }
          &.location-item-17 {
            --map-point-shift-x: 40.91px;
            --map-point-shift-y: -4.93px;
          }
          &.location-item-18 {
            --map-point-shift-x: 35.72px;
            --map-point-shift-y: 3.64px;
          }
        }

        &.parking,
        &.meeting,
        &.lobby,
        &.public,
        &.socialParking {
          &::before,
          &::after {
            transform: translateX(calc(-50% + var(--map-point-shift-x, 0px)))
              translateY(var(--map-point-shift-y, 0px));
          }
        }
      }
      &.cncc {
        &.location-item-0 {
          top: 230px;
          right: 76px;
          &::before {
            right: 2px;
            top: -32px;
            height: 38px;
          }
          &::after {
            right: -1px;
            top: -34px;
          }
        }
        &.location-item-1 {
          top: -36px;
          left: 0;
          &::before {
            height: 32px;
            right: 30px;
          }
          &::after {
            right: 27px;
            top: 56px;
          }
        }
        &.location-item-2 {
          top: -36px;
          right: 64px;
          &::before {
            height: 32px;
            right: 30px;
          }
          &::after {
            right: 27px;
            top: 56px;
          }
        }
        &.location-item-3 {
          top: 194px;
          left: 70px;
          &::before {
            height: 36px;
            right: 44px;
            top: -36px;
          }
          &::after {
            right: 41px;
            top: -39px;
          }
        }
        &.location-item-4 {
          top: 83px;
          left: 2px;
          &::before {
            height: 50px;
            right: -25px;
            top: -16px;
            transform: rotate(90deg);
          }
          &::after {
            right: -53px;
            top: 7px;
          }
        }
        &.location-item-5 {
          top: -6px;
          right: 114px;
          &::before {
            height: 12px;
            left: 83px;
            top: 26px;
          }
          &::after {
            left: 83px;
            top: 38px;
          }
        }
        &.location-item-6 {
          top: 42px;
          right: 0;
          &::before {
            height: 20px;
            right: 117px;
            top: 26px;
          }
          &::after {
            right: 114px;
            top: 44px;
          }
        }
        &.location-item-7 {
          top: 280px;
          left: 87px;
          &::before {
            height: 18px;
            right: 70px;
            top: 26px;
          }
          &::after {
            right: 67px;
            top: 42px;
          }
        }
        &.location-item-8 {
          top: 118px;
          left: 0;
          &::before {
            height: 32px;
            right: 56px;
          }
          &::after {
            right: 53px;
            top: 56px;
          }
        }
        &.location-item-9 {
          top: 36px;
          left: 0;
          &::before {
            height: 12px;
            right: 56px;
          }
          &::after {
            right: 53px;
            top: 36px;
          }
        }
        &.location-item-10 {
          top: 158px;
          right: 0;
          &::before {
            height: 12px;
            right: 4px;
            top: 23px;
          }
          &::after {
            right: 1px;
            top: 33px;
          }
        }
        &.location-item-11 {
          top: 336px;
          right: 120px;
          &::before {
            height: 38px;
            right: 72px;
            top: 26px;
          }
          &::after {
            right: 69px;
            top: 63px;
          }
        }
      }
    }
  }
  .exhibition-wrapper {
    &.shougang {
      margin-top: var(--exhibitionMargin);
    }
    background-color: #fff;
    padding: 2px 20px;
    .exhibition-container {
      position: relative;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;
      border: 1.5px solid #0051a566;
      border-radius: 16px;
      border-top: none;
      margin: 40px 0 80px 0;
      padding: 10px;
      width: 100%;
      z-index: 1;
      .title {
        position: absolute;
        top: -12px;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        text-align: left;
        strong {
          font-size: 18px;
          color: #222;
          margin-left: 8px;
        }
        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          margin-right: 30px;
          span {
            color: #999999;
            font-size: 12px;
          }
          img {
            height: 18px;
            width: 18px;
          }
        }
      }
      .exhibition-item {
        margin: 20px 10px;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        .left {
          min-width: 50px;
          padding: 10px 11px;
          font-size: 14px;
          line-height: 1;
          color: #fff;
          background-color: #00a0e8;
          text-align: center;
          width: 100%;
          max-width: fit-content;
          position: relative;
          &.yellow {
            background-color: #dfd13b;
            color: rgba(0, 0, 0, 0.6);
          }
        }
        &.cncc {
          &.cncc-1 {
            .left {
              background-color: #d72e28;
            }
          }
          &.cncc-2 {
            .left {
              background-color: #2e73c2;
            }
          }
          &.cncc-3 {
            .left {
              background-color: #7b278a;
            }
          }
          .left {
            min-width: 34px;
            width: 34px;
            height: 34px;
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              width: 80%;
              height: 80%;
              background-color: transparent;
              border: 1px solid #fff;
              transform: translate(-50%, -50%);
            }
          }
        }
        .right {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;
          position: relative;
          gap: 10px;
          .line {
            border: 1px dashed #e5e5e5;
            flex: 1;
          }
          img {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 320px) {
  .location-container {
    .location {
      span {
        font-size: 12px !important;
      }
    }
  }
  strong {
    font-size: 16px !important;
  }
}
</style>
